import { BottomNav } from "../components/BottomNav";
import { BrandHeader } from "../components/BrandHeader";
import { Icon } from "../components/Icon";
import type { RouteView } from "../hooks/useHashRoute";
import type { UiBriefing } from "../types";

export function SavedView({ briefing, savedIds, onStory, onNavigate, onSettings, onBrandTap }: { briefing: UiBriefing; savedIds: string[]; onStory: (id: string) => void; onNavigate: (view: RouteView) => void; onSettings: () => void; onBrandTap: () => void }) {
  const stories = briefing.stories.filter((story) => savedIds.includes(story.id));
  return (
    <>
      <BrandHeader onSettings={onSettings} onBrandTap={onBrandTap} />
      <main className="screen screen--with-nav utility-screen" id="main-content">
        <h1>Saved stories</h1>
        {stories.length ? <div className="saved-list">{stories.map((story) => <button type="button" key={story.id} onClick={() => onStory(story.id)}><div><span>{story.category}</span><h2>{story.headline}</h2><p>{story.sourceCount} publications · {story.independentChainCount} independent chains</p></div><Icon name="chevron" /></button>)}</div> : <div className="empty-state empty-state--saved"><Icon name="bookmark" size={40} /><h2>Nothing saved yet</h2><p>Use the bookmark on a story detail screen to keep it here.</p></div>}
      </main>
      <BottomNav selected="saved" onNavigate={onNavigate} />
    </>
  );
}
